import React, { useEffect } from "react";
import Refund from "../Home/Refund";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <Refund />
      <Footer />
    </>
  );
};

export default RefundPolicy;
